// extracted by mini-css-extract-plugin
export default {"itemview":"itemview_bd0eed202f493fcd6ecf","name":"name_d636493bed6aa6ddf7eb"};